import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'blu-channel-card',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterLink, NgClass],
  templateUrl: './channel-card.component.html',
  styleUrls: ['./channel-card.component.scss'],
  host: {
    class: 'group',
  },
})
export class ChannelCardComponent {
  @Input() channel: any;
  @Input() canAddAgent: () => boolean = () => false;
}
